import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { getEmotionCSSClass } from '../record/EmotionField'

type Emotion = {
  name: string,
  value: string,
}

type RecordInfo = {
  fact: string,
  subjectivity: string,
  beforeEmotion: Emotion[],
  objective: string,
  afterEmotion: Emotion[],
  rightAction: string,
  createdAt: string,
  updatedAt: string,
  editUrl: string,
  deleteUrl: string,
  canCoachRead: boolean,
}

interface Props {
  recordInfoStr: string
}

const RecordListTable: React.FC<Props> = (props) => {
  const records = JSON.parse(props.recordInfoStr) as RecordInfo[]; 
  const [show, setShow] = useState(false);
  const [deleteUrl, setDeleteUrl] = useState("");
  const [createdAt, setcreatedAt] = useState("");

  const openModal = (event: React.SyntheticEvent) => {
    const target = event.currentTarget as HTMLElement;
    setDeleteUrl(target.dataset.url as string)
    setcreatedAt(target.dataset.date as string)
    setShow(true)
  }

  const closeModal = () => setShow(false)

  const deleteModalDialog = () => (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>コラム記録の削除</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>「{createdAt}」のコラム記録を削除してもよろしいですか？</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={closeModal}>
          キャンセル
        </Button>
        <Button variant="danger" href={deleteUrl} data-method="delete">
          削除
        </Button>
      </Modal.Footer>
    </Modal>
  )

  return (
    <div className="card">
      <div className="card-body">
        {
          records.map((record, index) => (
            <div className="column-record">
              <div className="column-record-title">
                <div className="d-flex align-items-center">
                  <h3 className="mb-0">{record.createdAt}</h3>
                  { !record.canCoachRead && <span className="icon icon-lock" title="非公開"></span> }
                </div>
                <div>
                  <a href={record.editUrl} className="btn-icon" title="編集">
                    <span className="icon-edit"></span>
                  </a>
                  <a data-url={record.deleteUrl}　data-date={record.createdAt} onClick={openModal} className="btn-icon danger" title="削除">
                    <span className="icon-trash-2"></span>
                  </a>
                </div>
              </div>

              <div className="column-data">
                <span className="icon-book-open column-data-icon muted"></span>
                <div className="column-data-item">
                  <label>事実</label>
                  <div className="column-data-text">{record.fact}</div>
                </div>
                <span className="icon-message-circle column-data-icon muted"></span>
                <div className="column-data-item">
                  <label>考え</label>
                  <div className="column-data-text">{record.subjectivity}</div>
                </div>
                <span className="icon-heart column-data-icon muted"></span>
                <div className="column-data-item">
                  <label>感情</label>
                  <div className="column-data-text">
                    { record.beforeEmotion.map( (e) => <span className={`emotion-icon ${getEmotionCSSClass(e.name)}`}>{e.name}: <strong>{ e.value }%</strong></span> ) }
                  </div>
              </div>
                <span className="icon-message-circle column-data-icon"></span>
                <div className="column-data-item">
                  <label>別の考え</label>
                  <div className="column-data-text">{record.objective}</div>
                </div>
                <span className="icon-heart column-data-icon"></span>
                <div className="column-data-item">
                  <label>感情の変化</label>
                  <div className="column-data-text">
                    { record.afterEmotion.map( (e) => <span className={`emotion-icon ${getEmotionCSSClass(e.name)}`}>{e.name}: <strong>{ e.value }%</strong></span> ) }
                  </div>
                </div>
                <span className="icon-flag column-data-icon"></span>
                <div className="column-data-item">
                  <label>より適応した行動</label>
                  <div className="column-data-text">{record.rightAction}</div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
      {deleteModalDialog()}
    </div>
    

  )
}

export default RecordListTable